import { Stack, Text } from '@mantine/core'
import type { ClaimPresentPositions } from '@api-sdk'
import type { KeyDataItem } from '../../../types/keyDataItem'
import { KeyDataRow } from './KeyDataRow'
import { EditableKeyDataRow } from './EditableKeyDataRow'
import { PresentPositionEditor } from './editors/PresentPositionEditor'
import type { PresentPositionEdit } from '../../../hooks/usePresentPositionEdit'

export interface ClaimKeyDataProps {
  items: KeyDataItem[]
  onActionClick?: (item: string) => void
  // Present Position editing (the only editable field). When absent, all rows
  // render read-only.
  presentPositionEdit?: PresentPositionEdit
  presentPositionOptions?: ClaimPresentPositions[] | null
  presentPositionOptionsLoading?: boolean
  presentPositionOptionsError?: string | null
}

export function ClaimKeyData({
  items,
  onActionClick,
  presentPositionEdit,
  presentPositionOptions,
  presentPositionOptionsLoading,
  presentPositionOptionsError,
}: Readonly<ClaimKeyDataProps>) {
  return (
    <Stack gap="xs">
      <Text fz="xs" c="text.2">
        Summary of Key Data:
      </Text>
      <Stack gap={4}>
        {items.map((item: KeyDataItem) => {
          if (item.editor && presentPositionEdit) {
            const edit = presentPositionEdit
            return (
              <EditableKeyDataRow
                key={item.label}
                label={item.label}
                value={item.value}
                isDirty={edit.isDirty}
                canSave={edit.isDirty && edit.validationError == null}
                canCancel={edit.hasChanges}
                status={edit.state.status}
                message={edit.state.message}
                disabledReason={item.editor.disabledReason}
                onSave={() => edit.save()}
                onCancel={edit.cancel}
              >
                <PresentPositionEditor
                  value={edit.statusId}
                  description={edit.notes}
                  onValueChange={edit.setStatusId}
                  onDescriptionChange={edit.setNotes}
                  options={presentPositionOptions ?? null}
                  optionsLoading={presentPositionOptionsLoading}
                  optionsError={presentPositionOptionsError}
                  validationError={edit.validationError}
                />
              </EditableKeyDataRow>
            )
          }
          return (
            <KeyDataRow
              key={item.label}
              label={item.label}
              value={item.value}
              actionIcon={item.actionIcon}
              actionIconSize={item.actionIconSize}
              onActionClick={() => (onActionClick ? onActionClick(item.label) : undefined)}
            />
          )
        })}
      </Stack>
    </Stack>
  )
}
